import React from "react";

export const Legend = () => {
  return (
    <div className="legend">
      <ul>
        <li>Pacient s novým PF skóre N, 0 a 3 - 5</li>
        <li>Pacient s novým PF skóre 1 - 2</li>
        <li>PEN-FAST po zhodnocení KF</li>
        <li>PEN-FAST s challenge</li>
      </ul>
    </div>
  );
};
